/**
 * Inline text link on marketing pages: a hairline, light underline that darkens
 * on hover. One class string so every page's body links look the same; the
 * earlier dashed underline read as heavy next to the body text.
 */
export const INLINE_LINK_CLASS =
	'font-medium text-primary underline decoration-1 decoration-slate-300 underline-offset-4 transition-colors hover:decoration-primary';

/** Same underline on a secondary-coloured link (FAQ answers). */
export const MUTED_LINK_CLASS =
	'text-secondary underline decoration-1 decoration-slate-300 underline-offset-4 transition-colors hover:text-primary hover:decoration-primary';
